import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CalendarioAnualComponent } from '../../shared/components/calendario-anual/calendario-anual';

@Component({
  selector: 'app-inicio-publico',
  imports: [CommonModule, RouterLink, CalendarioAnualComponent],
  templateUrl: './inicio-publico.html',
  styleUrl: './inicio-publico.css',
})
export class InicioPublico {
  // Mensaje configurable de bienvenida para la portada publica.
  mensajeBienvenida =
    'Bienvenido a la plataforma que centraliza y simplifica los procesos de postulación a concursos y programas de ANID. Accede a información clara, realiza seguimiento y participa en igualdad de condiciones.';
  readonly calendarioAnidUrlOficial = environment.calendarioAnidUrlOficial;
  readonly usarCalendarioOficial = !!this.calendarioAnidUrlOficial;

  // Realiza scroll interno hacia el calendario sin recargar la vista.
  irACalendario(event: Event): void {
    event.preventDefault();
    const calendario = document.getElementById('calendario');
    if (!calendario) return;

    calendario.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => calendario.focus({ preventScroll: true }), 250);
  }
}
